import React, { useEffect, useState }  from 'react';

const PreviewRules = ({arrMassage, setArrMassage}) => {
    console.log('arrMassage', arrMassage);
    return (
        <div className='preview_verification_wrap'>
        <div className='preview_verification_header'>
            <img className='preview_verification_header_img' src="/img/BotAva.svg" alt="" />
            <h4>Themis</h4>
            <div className='preview_verification_header_lable'>
                <img src="/img/check_white.svg" alt="" />
                <p>BOT</p>
            </div>
            <p className='preview_verification_header_date'>Today at 15:36</p>
        </div>
        <div className='preview_verification_content'>
            <div className='preview_verification_captcha'>
                <h3>
                    <img src="/img/RulesPreview.svg" alt="" />
                    Accept the rules</h3>
                <h4>In order to proceed, please read and agree to the server rules. </h4>
                <div className='preview_verification_captcha_content'>
                    {arrMassage.map((item, idx) => (
                        <p>{item.text}</p>
                    ))}
                    <div className='preview_verification_captcha_content_info'>
                        <span>By clicking</span>
                        <img className='preview_verification_keyboadr_item_check' src={`/img/captcha/key/chek.svg`} alt="" />
                        <span>you agree to the rules described above. </span>
                    </div>
                </div>
            </div>
            <div className='preview_verification_keyboadr_wrap'>
            <div 
                className='preview_verification_keyboadr_item'
                >
                    <img className='preview_verification_keyboadr_item_check' src={`/img/captcha/key/chek.svg`} alt="" />
                </div>
            </div>

        </div>
    </div>
    );
};

export default PreviewRules;